import React, { memo,useEffect, useState } from "react";
import MenuCpn from "../../components/Menu/Menu-cpn";
import FooterCpn from "../../components/Footer/Footer-cpn";
import answer from "../../tools/data";
import { Wrap } from "./style";

export default memo(function FAQ(props) {
  const { id } = props.match.params;
  const currentData = answer[id-1];

  

  useEffect(() => {
    document.getElementById('root').scrollTop = 0;
    document.title = '投资者常见问题';
  }, []);

  const [currentAnswer, setCurrentAnswer] = useState([])
  useEffect(() => {
    if (currentData) {
      let result = currentData.answer.map(element => {
        element['flag'] = false;
        return element
      });
      setCurrentAnswer(result)
    }
  }, [currentData]);

  const open =(e,index)=>{
    currentAnswer[index].flag = !currentAnswer[index].flag;
    const result = currentAnswer.map(e=>e);
    setCurrentAnswer(result)
  }
  return (
    <>
      <MenuCpn></MenuCpn>
      <Wrap>
        <section>
          <div className="logo">
            {/* <img src={require('../../assets/img/3_07.png').default} alt=""/> */}
          </div>
          <h3>{currentData.name}</h3>
          <div className='box'>

            {
              currentAnswer.map((item,index)=>{
                return(
                  <div className="answer" key={item.question}>
                    <p className="question" onClick={e=>open(e,index)}>{item.question}</p>
                    {(item.flag) && <p className="right">{item.right}</p>}
                  </div>
                )
              })
            }
          </div>

        </section>
        <FooterCpn />
      </Wrap>
    </>
  );
});
